import React from "react";
import FileUploader from "../../common/fileupload";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import CancelButton from "../../common/button/cancelButton";

import {
  Box,
  FormControl,
  Modal,
  FormControlLabel,
  FormGroup,
  CircularProgress,
  Checkbox,
  Grid,
  TextField,
  styled,
  Switch,
  InputLabel,
  Select,
  MenuItem,
  Button,
  FormHelperText,
  Typography,
  Chip,
  TextareaAutosize,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  RadioGroup,
  Radio,
} from "@mui/material";
import { FaPlus } from "react-icons/fa";
export default function Index() {
  return (
    <>
      <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
        <FormControl sx={{ minWidth: 200 }}>
          <Select
            size="small"
            displayEmpty
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                },
              },
              disableScrollLock: true,
            }}
            sx={{
              width: "100%",
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "inherit",
              },
              "& .MuiOutlinedInput-root.Mui-focused": {
                boxShadow: "none",
              },
            }}
          >
            <MenuItem value={0}>Courses</MenuItem>
          </Select>
        </FormControl>

        <Button
          variant="outlined"
          // onClick={handleOpenModal}
          sx={{
            color: "black",
            borderColor: "#A3A3A3",
            minWidth: 50,
            height: 40,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FaPlus />
        </Button>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: "4px",
          px: 2, // If you meant padding on x-axis (left/right), otherwise use `mx`
        }}
      >
        Required documents
        <MauvelousPrimaryButton
          title="Add document"
          // handleClick={InitializeRefund}
        />
      </Box>

      <FileUploader Filename={"SSC(Std. X) Marksheet"} />
      <FileUploader Filename={"HSC / Diploma/ B.Sc Marksheet"} />
      <FileUploader Filename={"Qualifying exam marksheet"} />
      <FileUploader Filename={"Qualifying exam marksheet"} />
      <FileUploader Filename={"School leaving certificate"} />
      <FileUploader Filename={"Indian nationality certificate"} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "12px",
          marginTop: "32px",
        }}
      >
        <CancelButton />
        {/* handleBack={handleCloseModal} */}
        {MauvelousPrimaryButton({
          title: "Submit",
          // handleClick: handleSubmit(onSubmit),
        })}
      </Box>
    </>
  );
}
